import { render } from "./MainPortfolio.vue?vue&type=template&id=099d6f50&scoped=true"
import script from "./MainPortfolio.vue?vue&type=script&lang=js"
export * from "./MainPortfolio.vue?vue&type=script&lang=js"

import "./MainPortfolio.vue?vue&type=style&index=0&id=099d6f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099d6f50"]])

export default __exports__